export type ScheduleMode = 'query' | 'scenario';

/** Body for create/update. The inactive side is explicit null so an edit clears it. */
export function scheduleWriteBody(form: {
  name: string;
  mode: ScheduleMode;
  query_text: string;
  scenario_id: string;
  cron_expression: string;
  notification_method: string;
}): {
  name: string;
  query_text: string | null;
  scenario_id: string | null;
  cron_expression: string;
  notification_method: string;
} {
  const common = {
    name: form.name,
    cron_expression: form.cron_expression,
    notification_method: form.notification_method,
  };
  if (form.mode === 'scenario') {
    return { ...common, scenario_id: form.scenario_id, query_text: null };
  }
  return { ...common, query_text: form.query_text, scenario_id: null };
}
